<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    export let title: string = 'Something went wrong';
    export let description: string = 'We couldn’t load this view. Try again, or refresh the page.';
    export let retryLabel: string = 'Try again';
    export let showRetry: boolean = true;

    const dispatch = createEventDispatcher();
</script>

<div class="error-state" role="alert">
    <i class="exclamation triangle icon" aria-hidden="true"></i>
    <h2 class="error-title">{title}</h2>
    <p class="error-description">{description}</p>
    {#if showRetry}
        <button type="button" class="error-retry" on:click={() => dispatch('retry')}>
            <i class="redo icon" aria-hidden="true"></i>
            <span>{retryLabel}</span>
        </button>
    {/if}
</div>

<style>
    .error-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: var(--space-10) var(--space-5);
        min-height: 320px;
        color: var(--grey-secondary);
    }

    .error-state :global(i.exclamation.triangle.icon) {
        font-size: 3rem;
        color: var(--status-danger);
        opacity: .85;
        margin-bottom: var(--space-4);
    }

    .error-title {
        font-size: var(--text-xl);
        font-weight: 500;
        color: var(--grey);
        margin: 0 0 var(--space-2) 0;
    }

    .error-description {
        font-size: var(--text-base);
        margin: 0 0 var(--space-5) 0;
        max-width: 420px;
    }

    .error-retry {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
        padding: var(--space-3) var(--space-5);
        background: var(--surface);
        color: var(--grey);
        border: 1px solid var(--border-strong);
        border-radius: var(--radius-cta);
        font-weight: 500;
        cursor: pointer;
        transition: background-color .15s, border-color .15s;
    }

    .error-retry:hover {
        background: var(--surface-hover);
        border-color: var(--primary);
    }

    .error-retry:focus-visible {
        outline: none;
        box-shadow: var(--focus-ring);
    }
</style>
